// 환경별 설정 - 환경변수 우선 사용
const getConfig = () => {
  return {
    // API 엔드포인트 - 환경변수에서 가져오거나 기본값 사용
    API_ENDPOINT: process.env.REACT_APP_API_BASE_URL || 'https://your-api-endpoint.com/log',

    // 각 step별 리다이렉트 URL 설정 - 환경변수에서 가져오거나 기본값 사용
    REDIRECT_URLS: {
      step1: process.env.REACT_APP_REDIRECT_STEP1 || 'https://example.com',
      step2: process.env.REACT_APP_REDIRECT_STEP2 || 'https://example.com'
    },

    // deviceId별 리다이렉트 매핑의 공통 baseURL (환경별로 다름)
    REDIRECT_BASE_URL: process.env.REACT_APP_REDIRECT_BASE_URL || '',

    // deviceId별 path/query 매핑 (환경 공통)
    DEVICE_REDIRECT_MAP: {
      'b514d1b3-2500-4f10-9cd1-3efc30dd563e': {
        path: '/EVENT',
        query: 'id=emtk_8c',
      },
      'd42c58c8-dc3e-4f4a-896c-6f6f52ec7563': {
        path: '/EVENT',
        query: 'id=emtksk',
      },
      'e42ba0bb-6fc2-4cff-897f-11b86452a9a0': {
        path: '/EVENT',
        query: 'id=emtk_8h',
      },
    },

    // 기본 리다이렉트 URL - 환경변수에서 가져오거나 기본값 사용
    DEFAULT_REDIRECT_URL: process.env.REACT_APP_DEFAULT_REDIRECT_URL || 'https://example.com',

    // 로딩 화면 표시 임계값 (밀리초)
    LOADING_THRESHOLD: 500,

    // 개발 모드 (콘솔 로그 출력 여부) - 환경변수에서 가져오거나 기본값 사용
    DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE !== 'false'
  };
};

// 설정 파일
export const CONFIG = getConfig();